import React, { memo, useEffect, useMemo, useRef, useState } from "react";
import { connect, useDispatch, useSelector } from 'react-redux';
import { useTranslation } from "react-i18next";
import Layout from "../Layout";
import Title from "../Title";
import { Accordion, AccordionItem } from 'smart-webcomponents-react/accordion';
import 'smart-webcomponents-react/source/styles/smart.default.css';
import { Checkbox, Select, Switch } from "antd";
import { getuserroleandmenu } from "../../Redux/Actions/UsersActions";
import {
    fetchAllCompaniesdata, fetchAllSubCompaniesdata, fetchSitesByCompanyId, fetchSubCompaniesByUserId, fetchUpdatedUserSiteRelation, fetchUserById, fetchUserCompanyById, fetchUserSiteById,
    fetchusersitedata, getUserTreeViewData, fetchUserRoledata
} from "../../Redux/Api/fetch.api";
import { getallsubcompanydata } from "../../Redux/Actions/CompanyRelationAction";
import { getsitesbycompanyid } from "../../Redux/Actions/SiteActions";
import { getsubcompanybyuserid, postusercompanydata, updateusercompanydata } from "../../Redux/Actions/UserCompanyAction";
import * as url from "../../api/uri_helper";
import axios from "axios";
import toast, { Toaster } from "react-hot-toast";
import { getallcompanies } from "../../Redux/Actions/CompanyActions";
import { postusersitedata, updateusersitedata } from "../../Redux/Actions/UserSiteAction";

import Loader from "../loader";
import UserCompanyView from "./UserCompanyView";
import CompanySiteView from "./CompanySiteView";
import TreeNode from "./TreeNode"

const UserSetting = () => {
    const loggedUserId = localStorage.getItem('UserId')
    const { t } = useTranslation('userSettings');
    const dispatch = useDispatch();
    const [selectSubCompany, setSelectSubCompany] = useState([]);
    const [subCompanies, setSubCompanies] = useState([]);
    const [currentId, setCurrentId] = useState(null);
    const [userId, setUserId] = useState();
    const [userName, setUserName] = useState();
    const [loading, setLoading] = useState(false);
    const [isAccordionOpen, setIsAccordionOpen] = useState(true);
    const [isCompanyAdded, setIsCompanyAdded] = useState(false);
    const [companyId, setCompanyId] = useState(0);
    const [companyDetails, setCompanyDetails] = useState(false)
    const [allowUpdate, setAllowUpdate] = useState(false);
    const [allowMaintenance, setAllowMaintenance] = useState(false);
    const [allowNotification, setAllowNotification] = useState(false);
    const [allowSMS, setAllowSMS] = useState(false);
    const [siteId, setSiteId] = useState();
    const [userSiteId, setUserSiteId] = useState(null)
    const [allSubCompanies, setAllSubCompanies] = useState([]);
    const [allCompaniesData, setAllCompaniesData] = useState([]);
    const [sitesData, setSitesData] = useState([]);
    const [subCompanyId, setSubCompanyId] = useState();
    const [isAllSelected, setIsAllSelected] = useState(false);
    const [isCompanySiteAdded, setIsCompanySiteAdded] = useState(false)
    const [isSiteUpdateClick, setIsSiteUpdateClick] = useState(false)
    const [isCompanyEdit, setIsCompanyEdit] = useState(false)
    const [masterCompanyName, setMasterCompanyName] = useState('')
    const [userRole, setUserRole] = useState()
    const [supportStatus, setSupportStatus] = useState()
    const [openAccordion, setOpenAccordion] = useState("userCompany");
    const [filteredCompanyOptions, setFilteredCompanyOptions] = useState([]);
    const [treeData, setTreeData] = useState(null)
    const userCompanyRef = useRef(null);
    const userSiteRef = useRef(null);
    const userDetailsRef = useRef(null);
    const [roleId, setRoleId] = useState(null);

    useEffect(() => {
        
        let urlData = location.pathname.split('/');
        setCurrentId(urlData[2])

        if (currentId) {
            setLoading(true);
            fetchUserById(urlData[2]).then(
                response => {
                    setUserId(response.data.data.userId)
                    // setSiteId(response.data.data.siteId)
                    setUserName(response.data.data.firstName + ' ' + response.data.data.lastName)
                    setSubCompanyId(response.data.data.subCompanyId)
                    setMasterCompanyName(response.data.data.companyName);
                    setUserRole(response.data.data.roles?.map(x => x.roleName) || [])
                    setSupportStatus(response.data.data.isSupportCall)
                    setTimeout(()=>{
                        setLoading(false)
        
                    },[1000])
                })
            setTimeout(()=>{
                setLoading(false)

            },[1000])
            

        }

    }, [currentId])

    useEffect(() => {
        if (userId) {
            getSubCompanyData();
            getTreeViewData();
        }

    }, [userId]);

    useEffect(() => {       
        getRoleDetails();
    }, [])

    
    const getSubCompanyData = () => {
        fetchAllSubCompaniesdata()
            .then(response => {
                dispatch(getallsubcompanydata(response.data))
                setSubCompanies(response.data.data)
            })
            .catch((err) => {
                console.log("Err: ", err);
            });
    }

    const getCompany = (usercompany) => {
        let subcompany = [];
        usercompany.forEach(element => {
            let selectedSub = {
                disabled: undefined, key: element.companyId, label: element.companyName,
                value: element.companyId
            };
            subcompany.push(selectedSub);
        });
        return subcompany;
    }

    const handleAccordionToggle = (accordionName) => {
        setOpenAccordion((prev) => (prev === accordionName ? null : accordionName)); // Toggle logic

    };

    useEffect(() => {
        setLoading(true)
        let urlData = location.pathname.split('/');
        setCurrentId(urlData[2])
        if (isCompanyEdit) {
            fetchUserCompanyById(urlData[2]).then(
                response => {


                    setUserId(response.data.data.userId)
                    { response.data.data.companies ? setSelectSubCompany(getCompany(response.data.data.companies)) : "" }
                    setIsAccordionOpen(true)
                    setOpenAccordion("userCompany");
                    //setIsCompanyEdit(false)


                })
            
                setLoading(false)
           
        }
      
    }, [isCompanyEdit])

    useEffect(() => {
        setLoading(true);
        let urlData = location.pathname.split('/');

        if (isSiteUpdateClick || userSiteId) {

            fetchUserSiteById(userSiteId).then(
                response => {
                    setUserSiteId(response.data.data.userSiteId)
                    setSiteId(response.data.data.siteId)
                    setSubCompanyId(response.data.data.subCompanyId)
                    setAllowNotification(response.data.data.allowNotification)
                    setAllowSMS(response.data.data.allowSMS)
                    setAllowMaintenance(response.data.data.allowMaintenance)
                    setAllowUpdate(response.data.data.allowUpdate)
                    setOpenAccordion("")
                    setOpenAccordion("userSite");
                    //setIsSiteUpdateClick(false);
                })
            
                setLoading(false)
           

        }
        
    }, [isSiteUpdateClick, userSiteId])

    useEffect(() => {
        setIsAllSelected(selectSubCompany.length === subCompanies.length);
    }, [selectSubCompany, subCompanies]);

    const handleChangeSubCompany = (selected) => {

        const arr1 = []
        selected.map((item, i) => {
            subCompanies.filter(datas => datas.subCompanyName === selected[i].label).map(filter_data => {
                arr1.push(filter_data)
            })
        })
        setSelectSubCompany(selected)

    }

    const getRoleDetails = () => {
        if (loggedUserId == null) {
            history.push("/");
        }
        fetchUserRoledata(loggedUserId)
            .then(response => {
                dispatch(getuserroleandmenu(response.data))
                if (response.data.data.userRoleDetails[0].roleId)
                    setRoleId(response.data.data.userRoleDetails[0].roleId);

            })
            .catch((err) => {
                console.log("Err: ", err);
            });
    }

    const handleInputForCompanyDropdown = (input) => {

        const filtered = subCompanies && subCompanies.filter(item => {
            const fullName = item.subCompanyName;
            return fullName.toLowerCase().includes(input.toLowerCase());
        });
        setFilteredCompanyOptions(filtered);
    };

    // Handle "Select All" Checkbox Click
    const handleSelectAll = (e) => {
        if (e.target.checked) {
            setSelectSubCompany(subCompanies.map(item => item.subCompanyId));
            setIsAllSelected(true);
        } else {
            setSelectSubCompany([]);
            setIsAllSelected(false);
        }
    };

    const getSubCompanyIds = (selectedCompanies) => {
        let subcompany = [];
        selectedCompanies.map(companyItem => {
            return subcompany.push(companyItem.subCompanyId ? companyItem.subCompanyId : companyItem.value)
        })
        return subcompany;
    }

    const handleToggle = () => {

        setAllowNotification(!allowNotification);
    };

    const handleToggleSMS = () => {
        setAllowSMS(!allowSMS);
    };

    const handleToggleUpdate = () => {
        setAllowUpdate(prev => !prev);
        //  setAllowUpdate(!allowUpdate);
    };

    const handleToggleMaintenance = () => {
        setAllowMaintenance(prev => !prev);
    };

    const addUserCompanyData = async () => {
        setLoading(true)
        const formData = new FormData();
        formData.append("UserId", userId);
        const subCompanyIds = isAllSelected ? selectSubCompany : selectSubCompany.map(item => item.value);

        // Append each ID to the formData
        subCompanyIds.forEach(id => {
            formData.append('subcompany[]', id);
        });
        const response_ = await axios({
            method: 'post',
            url: url.POST_ADDUSERCOMPANY,
            data: formData,
        }).then(response => {
            if (response.data.success == false) {
                toast.error(t("CompanyAlreadyCreated"), {
                    className: "toastSuccess",
                });
                setSelectSubCompany([])
                selectSubCompany.push()
                setLoading(false)
                setIsCompanyAdded(true)
                setIsAccordionOpen(false)
                setFilteredCompanyOptions([])
                setAllowUpdate(false)
                setAllowMaintenance(false)
                setAllowNotification(false)
                setAllowSMS(false)
                filteredCompanyOptions.length = 0;
                setOpenAccordion("userSite")
            }
            else {
                dispatch(postusercompanydata(response.data))
                toast.success(t("UserCompanyRelationcreatedsuccessfully"), {
                    className: "toastSuccess",
                });
                setSelectSubCompany([])
                selectSubCompany.push()
                setLoading(false)
                setIsCompanyAdded(true)
                setIsAccordionOpen(false)
                setFilteredCompanyOptions([])
                setSubCompanyId()
                setSiteId()
                setAllowUpdate(false)
                setAllowMaintenance(false)
                setAllowNotification(false)
                setAllowSMS(false)
                filteredCompanyOptions.length = 0;
                setOpenAccordion("userSite")
            }
            getTreeViewData()
        })
    }

    const updateUserCompanyData = async () => {
        setLoading(true)
        setSubCompanyId(null);

        const subIdsToUpdate = getSubCompanyIds(selectSubCompany);
        const formData = new FormData();
        formData.append("UserId", userId);
        formData.append("IsActive", true);
        subIdsToUpdate.forEach((value) => {
            formData.append('subcompany[]', value);
        });
        const response_ = await axios({
            method: 'put',
            url: url.UPDATE_USER_COMPANY,
            data: formData,
        }).then(response => {
            if (response.data.success == false) {
                toast.error(t("CompanyAlreadyExists"), {
                    className: "toastSuccess",
                });
                setSelectSubCompany([])
                selectSubCompany.length = 0;
                setLoading(false)
                setIsCompanyAdded(true)
                setIsAccordionOpen(false)
                setOpenAccordion("userCompany")
                setIsCompanyEdit(false)
                setSiteId()
                setAllowUpdate(false)
                setAllowMaintenance(false)
                setAllowNotification(false)
                setAllowSMS(false)
            }
            else {
                dispatch(updateusercompanydata(response.data))
                toast.success(t("UserCompanysuccessfullyupdated"), {
                    className: "toastSuccess",
                });
                setSelectSubCompany([])
                selectSubCompany.length = 0;
                setLoading(false)
                setIsCompanyAdded(true)
                setIsAccordionOpen(false)
                setIsCompanyEdit(false)
                setSiteId()
                setAllowUpdate(false)
                setAllowMaintenance(false)
                setAllowNotification(false)
                setAllowSMS(false)
                setOpenAccordion("")
            }
            setLoading(false)
            getTreeViewData()
        })
    }

    let pageButton = t("Next")
    if (isCompanyEdit) {
        pageButton = t("Update")
        // setIsAccordionOpen(false)
    }

    let pageButtonForSites = t("Save")
    if (isSiteUpdateClick) {
        pageButtonForSites = t("Update")
    }

    const updateUserSiteData = async () => {
        setLoading(true)
        fetchUpdatedUserSiteRelation({
            UserSiteId: userSiteId,
            UserId: userId,
            SiteId: siteId,
            RoleId: 8,
            SubCompanyId: subCompanyId ? subCompanyId : companyId,
            AllowNotification: allowNotification,
            AllowSMS: allowSMS,
            AllowUpdate: allowUpdate,
            AllowMaintenance: allowMaintenance
        }).then(response => {
            dispatch(updateusersitedata(response.data))
            if (!response.data.success) // False 
            {
                toast.error(t("CompanyRelationAlreadyAdded"), {
                    className: "toastSuccess",
                },);
                setIsCompanySiteAdded(true)
                setIsAccordionOpen(false)
                setIsSiteUpdateClick(false)
                setUserSiteId()
                setSubCompanyId()
                setSiteId()
                setAllowUpdate()
                setAllowMaintenance()
                setAllowNotification()
                setAllowSMS()
                setOpenAccordion("")
                setLoading(false);
            }
            else {
                toast.success(t("CompanyRelationupdatedsuccessfully"), {
                    className: "toastSuccess",
                },);
                setIsCompanySiteAdded(true)
                setIsAccordionOpen(false)
                setUserSiteId()
                setIsSiteUpdateClick(false)
                setSubCompanyId()
                setSiteId()
                setAllowUpdate()
                setAllowMaintenance()
                setAllowNotification()
                setAllowSMS()
                setOpenAccordion("")
                setLoading(false);
            }
            getTreeViewData()
        })
    }

    const handleCancelCompany = () => {
        setOpenAccordion("")
        setSelectSubCompany([])
        selectSubCompany.length = 0;
    }

    const handleCancelSite = () => {
        setSubCompanyId()
        setSiteId()
        setAllowUpdate()
        setAllowMaintenance()
        setAllowNotification()
        setAllowSMS()
        setOpenAccordion("")
    }

    useEffect(() => {
        if (userId || isCompanyAdded) {
            getallcompaniesdata();
            getSubCompaniesDetails();
        }

    }, [userId, isCompanyAdded]);

    const getSubCompaniesDetails = () => {
        fetchSubCompaniesByUserId(userId)
            .then(response => {
                dispatch(getsubcompanybyuserid(response.data))
                setAllSubCompanies(response.data.data.companyUserdata)
                const companyData = response.data.data.companyUserdata || [];

                if (companyData.length > 0) {
                    // Store all company IDs in an array
                    const companyIds = companyData.map(company => company.subCompanyId);
                    setAllSubCompanies(companyData);
                    setCompanyId(companyIds); // Store multiple company IDs
                    setCompanyDetails(true)
                    setIsCompanyAdded(false)
                } else {
                    setAllSubCompanies([]);
                    setCompanyId([]); // Ensure it's an empty array when no companies exist
                }
            })
            .catch((err) => {
                console.log("Err: ", err);
            })
    }

    useEffect(() => {
        if (subCompanyId) {
            getCompanysiteDetails();
        }

    }, [subCompanyId]);

    const getCompanysiteDetails = () => {

        fetchSitesByCompanyId(subCompanyId ? subCompanyId : companyId)
            .then(response => {
                dispatch(getsitesbycompanyid(response.data))
                setSitesData(response.data.data)
            })
            .catch((err) => {
                console.log("Err: ", err);
            })
    }

    const getallcompaniesdata = () => {
        //setLoading(true)
        fetchAllCompaniesdata()
            .then(response => {
                dispatch(getallcompanies(response.data))
                setAllCompaniesData(response.data.data)
            })
            .catch((err) => {
                console.log("Err: ", err);
            });
        //setLoading(false)
    }

    const addUserSiteData = async () => {
        setLoading(true)
        fetchusersitedata({
            UserId: userId,
            SiteId: siteId,
            RoleId: 8,
            SubCompanyId: subCompanyId ? subCompanyId : companyId,
            AllowNotification: allowNotification,
            AllowSMS: allowSMS,
            AllowUpdate: allowUpdate,
            AllowMaintenance: allowMaintenance
        }).then(response => {
            dispatch(postusersitedata(response.data))
            if (!response.data.success) // False 
            {
                toast.error(t("UserSiteRelationalreadycreated"), {
                    className: "toastSuccess",
                },);
                setIsCompanySiteAdded(true)
                setSubCompanyId()
                setSiteId()
                setAllowUpdate()
                setAllowMaintenance()
                setAllowNotification()
                setAllowSMS()
                setLoading(false);
            }
            else {
                toast.success(t("UserSiteRelationCreatedsuccessfully"), {
                    className: "toastSuccess",
                },);
                setIsCompanySiteAdded(true)
                setSubCompanyId()
                setSiteId()
                setAllowUpdate()
                setAllowMaintenance()
                setAllowNotification()
                setAllowSMS()
                setOpenAccordion("")
                setLoading(false);
                // setDisable(true)
            }
            getTreeViewData()
        })
            .catch((err) => {
                console.log("Err: ", err);
            });

    }

    const handleSelectSubCompany = (selectedValues) => {
        setSubCompanyId(selectedValues.value);  // Storing only the values
        setSiteId();

    }

    // Get User's tree view data 
    const getTreeViewData = async () => {
        try {
            const response = await getUserTreeViewData(userId);
            setTreeData(response.data.data);
        } catch (err) {
            console.error("Error fetching tree data:", err);
        }
    };


   
    return (
        <div>
            <Title title={t("UserSettings")}></Title>
            {roleId == null ? <Loader /> :
                <>
                    {loading ? <Loader /> : ''}
                    <Layout>
                        <section className="UserSetting-accordion appsdata">
                            <Toaster />

                            <div className="container-fluid">
                                <div className="row" style={{ rowGap: "25px" }}>


                                    <div className="col-lg-5">
                                        <div className="binary-box">
                                            <div className="user-details">

                                                <h4><span>{t("UserName")}:</span> <span>{userName}</span></h4>
                                                <h4><span>{t("Role")}:</span> <span>{userRole}</span></h4>
                                                <h4><span>{t("MasterCompany")}:</span> <span> {masterCompanyName}</span></h4>
                                                <h4 className="m-0"><span>{t("SupportCallStatus")}:</span> <span>{supportStatus == true ? "Yes" : "No"}</span></h4>
                                            </div>
                                            <div class="accordion user-setting-accordion" id="accordionExample">

                                                <div class="accordion-item">
                                                    <h2 class="accordion-header" id="headingTwo">
                                                        {/* <button class="accordion-button" type="button" data-bs-toggle="collapse" data-bs-target="#collapseOne" aria-expanded="true" aria-controls="collapseOne" onClick={() => handleAccordionToggle("userCompany")} > */}
                                                        <button
                                                            class={`accordion-button ${openAccordion === "userCompany" ? "" : "collapsed"}`}
                                                            type="button"
                                                            data-bs-toggle="collapse"
                                                            data-bs-target="#collapseTwo"
                                                            aria-expanded={openAccordion === "userCompany"}
                                                            aria-controls="collapseTwo"
                                                            onClick={() => handleAccordionToggle("userCompany")}
                                                        >
                                                            {t("UserCompany")}
                                                        </button>
                                                    </h2>

                                                    {/* user company */}
                                                    <div id="collapseTwo" ref={userCompanyRef} className={`accordion-collapse collapse ${openAccordion === "userCompany" ? "show" : ""}`} aria-labelledby="headingTwo" data-bs-parent="#accordionExample">
                                                        <div class="accordion-body">
                                                            <div className="row">
                                                                <div className="col-md-12 select-Company comdropdown filter-wrap form-group m-0">
                                                                    <label>{t("SubCompany")} <span className="required-fields text-danger"> * </span></label>


                                                                    <Select className="company-drop"
                                                                        placeholder={t("SelectSubcompany")} tokenSeparators={[" ", ","]}
                                                                        filterOption={false}
                                                                        style={{ width: '100%' }}
                                                                        onChange={handleChangeSubCompany}
                                                                        mode="multiple"
                                                                        labelInValue
                                                                        value={selectSubCompany}
                                                                        onSearch={(value) => {
                                                                            handleInputForCompanyDropdown(value)
                                                                        }}
                                                                        dropdownRender={menu => (
                                                                            <>
                                                                                {
                                                                                    filteredCompanyOptions.length > 0 ? "" :

                                                                                        <div style={{ padding: "8px", borderBottom: "1px solid #f0f0f0" }}>
                                                                                            <Checkbox checked={isAllSelected} onChange={handleSelectAll}>
                                                                                                {t("Select All")}
                                                                                            </Checkbox>
                                                                                        </div>
                                                                                }
                                                                                {menu}

                                                                            </>
                                                                        )}
                                                                    >


                                                                        {filteredCompanyOptions.length > 0 ?
                                                                            filteredCompanyOptions && filteredCompanyOptions.map(item =>
                                                                                <Option key={item.subCompanyId} value={item.subCompanyId}>
                                                                                    {item.subCompanyName}
                                                                                </Option>
                                                                            )
                                                                            :
                                                                            subCompanies && subCompanies.map(item =>
                                                                                <Option key={item.subCompanyId} value={item.subCompanyId}>
                                                                                    {item.subCompanyName}
                                                                                </Option>
                                                                            )}
                                                                    </Select>
                                                                </div>
                                                            </div>

                                                            <div className="mt-3">
                                                                <div className="d-flex gap-3 justify-content-end align-items-center">
                                                                    {selectSubCompany?.length > 0 ? (
                                                                        <button className="btn btn-primary"
                                                                            onClick={!isCompanyEdit
                                                                                ? addUserCompanyData
                                                                                : updateUserCompanyData}>
                                                                            {pageButton}
                                                                        </button>
                                                                    ) : (
                                                                        <button className="btn btn-primary" disabled
                                                                            onClick={!isCompanyEdit
                                                                                ? addUserCompanyData
                                                                                : updateUserCompanyData}>
                                                                            {pageButton}
                                                                        </button>
                                                                    )}
                                                                    <button className="btn px-4 py-2 btn-bordered" onClick={handleCancelCompany}>{t("Cancel")}</button>
                                                                </div>
                                                            </div>

                                                        </div>
                                                    </div>
                                                </div>

                                                <div class="accordion-item">
                                                    <h2 class="accordion-header" id="headingThree">
                                                        {/* <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#collapseTwo" aria-expanded="false" aria-controls="collapseTwo" onClick={() => handleAccordionToggle("userSite")} > */}
                                                        <button
                                                            class={`accordion-button ${openAccordion === "userSite" ? "" : "collapsed"}`}
                                                            type="button"
                                                            data-bs-toggle="collapse"
                                                            data-bs-target="#collapseThree"
                                                            aria-expanded={openAccordion === "userSite"}
                                                            aria-controls="collapseThree"
                                                            onClick={() => handleAccordionToggle("userSite")}
                                                        >
                                                            {t("UserSite")}
                                                        </button>
                                                    </h2>

                                                    <div id="collapseThree" ref={userSiteRef} className={["accordion-collapse collapse", openAccordion == "userSite" ? "show" : "",].join(" ")} aria-labelledby="headingThree" data-bs-parent="#accordionExample" >
                                                        <div class="accordion-body">
                                                            <div className="row">
                                                                <div className="col-md-6 select-Company comdropdown filter-wrap form-group">
                                                                    <label>{t("SubCompany")} <span className="required-fields text-danger"> * </span></label>
                                                                    <Select className="company-drop"
                                                                        placeholder={t("SelectSubcompany")}
                                                                        labelInValue
                                                                        filterOption={false}
                                                                        style={{ width: '100%' }}
                                                                        value={subCompanyId}
                                                                        key={subCompanyId}
                                                                        onChange={(selectedValues) => {
                                                                            handleSelectSubCompany(selectedValues)
                                                                        }}
                                                                    >
                                                                        {
                                                                            allSubCompanies && allSubCompanies.map(sub =>
                                                                                <Option key={sub.subCompanyId} value={sub.subCompanyId}>
                                                                                    {sub.subCompanyName} </Option>
                                                                            )
                                                                        }

                                                                    </Select>
                                                                </div>

                                                                <div className="col-md-6 select-Company comdropdown filter-wrap form-group">
                                                                    <label>{t("Site")} <span className="required-fields text-danger" > * </span></label>
                                                                    <Select className="company-drop"
                                                                        placeholder={t("SelectSite")}
                                                                        labelInValue
                                                                        filterOption={false}
                                                                        style={{ width: '100%' }}
                                                                        value={siteId}
                                                                        key={siteId}
                                                                        onChange={(e) => setSiteId(e.value)}
                                                                    >
                                                                        {
                                                                            sitesData && sitesData.map(site =>
                                                                                <Option key={site.siteId} value={site.siteId}>
                                                                                    {site.siteName} </Option>
                                                                            )
                                                                        }

                                                                    </Select>
                                                                </div>
                                                                <div className="col-md-12">
                                                                    <div class="settings-container position-relative m-0" style={{ maxWidth: '100%' }}>
                                                                        <h1 class="container-title">{t("PropertiesforSupportRequest")}</h1>
                                                                        <div className="d-flex flex-wrap gap-10">

                                                                            <div className="alarm-toggle--wrap d-inline-block">

                                                                                <Switch
                                                                                    id="allowNotifications"
                                                                                    className="ms-2"
                                                                                    checked={allowNotification}
                                                                                    onChange={handleToggle}
                                                                                />

                                                                                <label className="alarm-toggle-label ml-2">{t("AllowNotifications")}</label>
                                                                            </div>

                                                                            <div className="alarm-toggle--wrap d-inline-block">

                                                                                <Switch
                                                                                    id="allowSMS"
                                                                                    className="ms-2"
                                                                                    checked={allowSMS}
                                                                                    onChange={handleToggleSMS}
                                                                                />

                                                                                <label className="alarm-toggle-label ml-2">{t("AllowSMS")}</label>
                                                                            </div>

                                                                            <div className="alarm-toggle--wrap d-inline-block">

                                                                                <Switch
                                                                                    id="allowUpdate"
                                                                                    className="ms-2"
                                                                                    checked={allowUpdate}
                                                                                    onChange={handleToggleUpdate}
                                                                                />

                                                                                <label className="alarm-toggle-label ml-2">{t("AllowUpdate")}</label>
                                                                            </div>

                                                                            <div className="alarm-toggle--wrap d-inline-block">

                                                                                <Switch
                                                                                    id="allowMaintenance"
                                                                                    className="ms-2"
                                                                                    checked={allowMaintenance}
                                                                                    onChange={handleToggleMaintenance}
                                                                                />

                                                                                <label className="alarm-toggle-label ml-2">{t("AllowMaintenance")}</label>
                                                                            </div>
                                                                        </div>
                                                                    </div>

                                                                </div>
                                                            </div>


                                                            <div className="mt-3">
                                                                <div className="d-flex gap-3 justify-content-end align-items-center">
                                                                    {/* <button className="btn px-4 py-2 btn-primary" onClick={addUserSiteData}>Save</button> */}
                                                                    {
                                                                        siteId && siteId != "Select Site" && companyId?.length > 0 ? <button className="btn px-4 py-2 btn-primary"
                                                                            onClick={!isSiteUpdateClick ? addUserSiteData : updateUserSiteData}>{pageButtonForSites}</button>
                                                                            : <button className="btn px-4 py-2 btn-primary" disabled
                                                                                onClick={!isSiteUpdateClick ? addUserSiteData : updateUserSiteData}>{pageButtonForSites}</button>
                                                                    }
                                                                    <button className="btn px-4 py-2 btn-bordered" onClick={handleCancelSite}>{t("Cancel")}</button>
                                                                </div>
                                                            </div>

                                                        </div>
                                                    </div>
                                                </div>
                                            </div>

                                        </div>
                                    </div>

                                    {treeData && (
                                        <div className="col-lg-7">
                                            <div className="binary-box binary-diagram">
                                                <h4 className="mb-3">{t("BinaryTreeView")}</h4>

                                                <div className="tree">
                                                    <TreeNode node={treeData} />
                                                </div>
                                            </div>

                                        </div>
                                    )}

                                    {
                                        allSubCompanies || isCompanyAdded ?
                                            <div className="col-lg-5"><UserCompanyView allSubCompanies={allSubCompanies} roleId={roleId} setIsAccordionOpen={setIsAccordionOpen} setIsCompanyAdded={setIsCompanyAdded} setIsCompanyEdit={setIsCompanyEdit} setSubCompanyId={setSubCompanyId} setSiteId={setSiteId} setAllowNotification={setAllowNotification} setAllowSMS={setAllowSMS}
                                                setAllowMaintenance={setAllowMaintenance} setAllowUpdate={setAllowUpdate} handleAccordionToggle={handleAccordionToggle} setOpenAccordion={setOpenAccordion} isCompanyAdded={isCompanyAdded} setIsSiteUpdateClick={setIsSiteUpdateClick} /></div>
                                            : ''
                                    }

                                    {allSubCompanies || isCompanySiteAdded ?
                                        <div className="col-lg-7"><CompanySiteView companyId={companyId} roleId={roleId}
                                            userId={userId} isCompanySiteAdded={isCompanySiteAdded} setIsCompanyAdded={setIsCompanyAdded} setIsCompanySiteAdded={setIsCompanySiteAdded}
                                            setIsSiteUpdateClick={setIsSiteUpdateClick} setIsAccordionOpen={setIsAccordionOpen} setUserSiteId={setUserSiteId} handleAccordionToggle={handleAccordionToggle} setOpenAccordion={setOpenAccordion} setIsCompanyEdit={setIsCompanyEdit} getTreeViewData={getTreeViewData} /></div>
                                        : ''}
                                </div>
                            </div>
                        </section>
                    </Layout>
                </>
            }
        </div>
    )
}
export default UserSetting